<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <div :class="['row']">
                    <div :class="['col-lg-8', 'col-md-12']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-3']">{{Noticia.titulo}}</h3>
                                <hr :class="['mt-1', 'mb-3']">

                                <div :class="['row']">
                                    <div :class="['col-lg-12']">
                                        <div class="entry-thumb-meta">
                                            <div class="entry-thumb">
                                                <img :src="Noticia.path_file_imagen" width="100%" alt="" title="">
                                            </div>

                                            <div class="entry-meta bg_color_drasam"> 
                                                <div class="date">
                                                    <span :class="['fa', 'fa-calendar', 'mr-2']"></span>
                                                    <p>{{obtenerNombreMes(Noticia.mes)}} {{Noticia.dia}} de {{Noticia.anio}}</p>
                                                </div>
                                                <span class="rounded-bend"> </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="['row', '']">
                                    <div :class="['col-lg-12', 'mt-4']">
                                        <div style="text-align: justify;" v-html="Noticia.contenido"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div :class="['col-lg-4', 'col-md-4', 'p4']">
                        <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm']">
                            <div :class="['box-header', 'with-border']">
                                <h5 :class="['box-title', 'pt-2', 'pb-0', 'mb-0', 'bolder']" >NOTICIAS RECIENTES</h5>
                            </div>

                            <hr :class="['mb-1', 'mt-1']">
                            <div :class="['box-body']" style=" ">
                                <div :class="['list-group', 'pb-1']">
                                    <ul :class="['widget']">
                                        <li v-for="(val, key) in Noticias" :key="key">
                                            <router-link :class="['thumb']" :to="'/noticia/'+val.id" href="" title="">
                                                <img :src="val.imagen?val.path_file_imagen:'no-disponible.png'" style="width:80px; height:60px" alt="" title="">
                                            </router-link>
                                            <h6 style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                                                <router-link :to="'/noticia/'+val.id" >{{val.titulo}}</router-link>
                                            </h6>
                                            <div class="commentmetadata"><i :class="['fa', 'fa-calendar', 'mr-2']"></i>Fecha Noticia {{val.dia}} {{obtenerNombreMes(val.mes)}} {{val.anio}} </div>
                                        </li>

                                        <li>
                                            <router-link :to="'/noticias?pag=1'" :class="['btn', 'btn-primary', 'btn-block']">VER MAS </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import Grid from  '@/layout/Grid.vue';
    export default {
        name: 'Noticia',
        components:{
            Grid,
        },
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Noticia || "+((this.empresa.abreviatura)?this.empresa.abreviatura:"DRASAM");
            this.getNoticia();
            this.getNoticias();
        },
        data(){
            return{
                id: (this.$route.params.id)?this.$route.params.id:1,
                Anio:[],
                formSearch:{
                    anio: (new Date()).getFullYear(),
                    mes:this.str_pad(((new Date()).getMonth()+1), 2, '0', 'STR_PAD_LEFT'),
                },
                Noticia:{},
                Noticias:[],
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            getNoticia(){
                this.setLoading(true);
                this.$http.get('webserviceserver/nota_prensa/'+this.id).then((res)=>{
                    this.Noticia = res.data.New;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
            getNoticias(){
                this.setLoading(true);
                
                this.$http.get('webserviceserver/notas_prensa?limit=12').then((res)=>{
                    this.Noticias   = res.data.News;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>